import { render } from "./ModuleCreate.vue?vue&type=template&id=296c59fe"
import script from "./ModuleCreate.vue?vue&type=script&lang=js"
export * from "./ModuleCreate.vue?vue&type=script&lang=js"

import "./ModuleCreate.vue?vue&type=style&index=0&id=296c59fe&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__